import { cn } from '~/src/lib/utils'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  borderNone?: boolean
  picksBackground?: boolean
}

const OurPicksContrainer: React.FC<Props> = ({
  children,
  className,
  borderNone,
  picksBackground,
  ...props
}) => {
  return (
    <div className='flex flex-col items-start'>
      <div className='relative w-full'>
        <div
          className={cn(
            'md:dark:border-darkborder bg-picks dark:bg-darkbg relative border-2 border-l-0 border-r-0 border-black md:rounded-lg md:border-l-2 md:border-r-2',
            {
              '!border-none': borderNone,
              '!bg-transparent': !picksBackground,
            },
            className
          )}
          {...props}
        >
          {children}
        </div>
      </div>
    </div>
  )
}

export default OurPicksContrainer
